import loginsplash from "@/assets/images/login-splash.png";

const SplashScreen = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-surface-splash">
      <div className="flex flex-col items-center">
        {/* Centered Image */}
        <img
          src={loginsplash}
          alt="AI Flowchart"
          height={300}
          width={300}
          loading="lazy"
        />

        {/* Bouncing Loader */}
        <div className="flex space-x-2 mt-8">
          <div
            className="w-4 h-4 bg-primary rounded-full animate-bounce"
            style={{ animationDelay: "0s" }}
          ></div>
          <div
            className="w-4 h-4 bg-primary rounded-full animate-bounce"
            style={{ animationDelay: "0.2s" }}
          ></div>
          <div
            className="w-4 h-4 bg-primary rounded-full animate-bounce"
            style={{ animationDelay: "0.4s" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
